var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("MJP 的 Instance")]),_c('p',[_vm._v("Instance（实例）基于 Application 生成。每个 Application 类型可以拥有不限制数量的实例。")]),_c('p',[_vm._v("一个实例可以用于单个游戏， 也可以用于多个游戏。")])])])])
}]

export { render, staticRenderFns }